import { createAction, props } from '@ngrx/store';

export const systemLoadingAction = createAction('[Loading] Set Loading state', props<{ loading: boolean }>());
